import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ConfigService {
  private readonly CONFIG_KEY = 'configuracion';
  private config: BehaviorSubject<Record<string, any>> = new BehaviorSubject({});

  get config$(): Observable<Record<string, any>> {
    return this.config.asObservable();
  }

  get snapshot(): Record<string, any> {
    return this.config.value;
  }

  constructor(private storage: Storage) {}

  async loadFromStorage(): Promise<void> {
    const saved = await this.storage.get(this.CONFIG_KEY);
    if (saved) {
      this.config.next(saved);
    }
  }

  async setFromLogin(config: Record<string, any>): Promise<void> {
    this.config.next(config || {});
    await this.storage.set(this.CONFIG_KEY, config || {});
  }

  getValue(key: string): any {
    return this.config.value[key];
  }

  isEnabled(key: string): boolean {
    const value = this.getValue(key);
    return value === '1' || value === 1 || value === true;
  }
}
